/*
===============================|> AUTH APIS <|===============================
01 |--> Login Api
02 |--> Register Api
03 |--> reset password:
|--> send email 
|--> send otp api and verify otp 
|--> change password
===============================|> AUTH APIS <|===============================
*/

import axios from '../axios-config';

// 01 --> Login api
const logInByEmail = async (username, password, recaptchaToken) => {
  const data = JSON.stringify({ username, password });
  const config = {
    method: 'post',
    url: '/customer/v2/login',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);

    return req;
  } catch (error) {
    return error;
  }
};

// 02 --> Login api => used
const logInByMobile = async (mobilenumber, recaptchaToken) => {
  const data = JSON.stringify({
    mobilenumber,
    otptype: 'login',
    email: '',
    resendotp: '',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/v2/login/otp/send',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used
const logInVerifyOtp = async (mobilenumber, otpcode, recaptchaToken) => {
  const data = JSON.stringify({
    mobilenumber,
    otpcode,
    otptype: 'login',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/v2/login/otp/verify',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used
const forgetVerifyOtp = async (
  mobilenumber,
  otpcode,
  otptype = 'forgot',
  recaptchaToken
) => {
  const data = JSON.stringify({
    mobilenumber,
    otpcode,
    otptype,
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/v2/forget/otp/verify',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04 --> reset password: 1--> Send otp email api => used
const forgetSendOtpEmail = async (email, recaptchaToken) => {
  const data = JSON.stringify({
    email,
  });
  const config = {
    method: 'post',
    url: '/customer/v2/emailResetToken',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used
const forgetSendOtpMobile = async (mobilenumber, recaptchaToken) => {
  const data = JSON.stringify({
    mobilenumber,
    otptype: 'forgot',
    email: '',
    resendotp: '',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/v2/forget/otp/send',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 05 --> reset password: 3--> verify otp and change new password api => used
const resetNewPassword = async ({
  email,
  newPassword,
  confirmPassword,
  resetToken,
  recaptchaToken,
}) => {
  const data = JSON.stringify({
    email,
    newPassword,
    confirmPassword,
    resetToken,
  });
  const config = {
    method: 'post',
    url: '/customer/v2/forgetPassword',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used
const resetNewPasswordByMobile = async (
  mobilenumber,
  password,
  recaptchaToken
) => {
  const data = JSON.stringify({
    mobilenumber,
    password,
  });
  const config = {
    method: 'post',
    url: '/customer/v2/forget/resetpassword',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used
const registerCreate = async (body, recaptchaToken) => {
  const data = JSON.stringify(body);
  const config = {
    method: 'post',
    url: '/customer/v2/register/account/create',
    data,
    headers: {
      woocommerce: `Bearer ${recaptchaToken}`,
      appname: 'Bearer next',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  logInByEmail,
  logInByMobile,
  logInVerifyOtp,
  forgetVerifyOtp,
  forgetSendOtpEmail,
  forgetSendOtpMobile,
  resetNewPassword,
  resetNewPasswordByMobile,
  registerCreate,
};
